<template>
	<div>

		<v-card class="elevation-12">
			<v-toolbar
				color="primary"
				dark
				flat
			>
				<v-toolbar-title>Iniciar sesión</v-toolbar-title>
			</v-toolbar>
			<v-card-text>
				<v-form>
					<v-text-field
						label="Dirección de correo electrónico"
						prepend-icon="mdi-at"
						type="email"
						v-model="datos.correo"
						@keypress.enter="acceder"
					></v-text-field>
					<v-text-field
						label="Contraseña"
						prepend-icon="mdi-lock-reset"
						type="password"
						minlenght="6"
						v-model="datos.contraseña"
						@keypress.enter="acceder"
					></v-text-field>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					color="primary"
					:loading="$root.autenticación.autenticando || $root.autenticación.cargandoUsuario"
					:disabled="desactivado"
					@click="acceder"
				>
					Ingresar
				</v-btn>
			</v-card-actions>
		</v-card>

	</div>
</template>

<script>

export default {
	name: 'ingreso',
  data: () => ({
		datos: {
			correo: '',
			contraseña: '',
		},
	}),
	computed: {
		desactivado: function () {
			return !this.datos.correo || !this.datos.contraseña
		}
	},
	methods: {
		acceder: function(){
			if (this.desactivado) {
				return
			}

			this.$root.autenticación.autenticando = true

			this.$root.firebase.auth().signInWithEmailAndPassword(this.datos.correo, this.datos.contraseña).then( () => {
				this.$emit('ingresar')
			}).catch( error => {
				let err = '[2345] Ocurrió un error'
				if (error.code === 'auth/invalid-email') {
					err = 'Correo electrónico no válido'
				} else if (error.code === 'auth/wrong-password' || error.code === 'auth/user-not-found') {
					err = 'Correo o contraseña errados'
				}
				this.$root.error(err)
				console.error(error.code, error.message)
				this.$root.autenticación.autenticando = false
			});
		}
	}
}
</script>